'use client';

import { __awaiter, __generator, __assign } from '../../_virtual/_tslib.js';
import { ELanguage } from '../../Utils/constants.js';
import { objToQueryStr } from '../../Utils/urlBuilder.js';
import ModelError from '../model/index.js';
import { CHANGE_JOB_TITLE, CHANGE_PHONE_NUMBER, PROFILE_LEVEL, RESUME_SETTING_INFO, JOBLEVEL, USER_SKILL, BASIC_INFO_V2, ENDPOINT_UPDATE_RESUME_FILE, ATTACHED_RESUME_VALIDATE, PROFILE_COOKIE, SEARCHABLE, REFRESH_PROFILE, BASIC_INFO, SKILL_TAGS } from './const.js';
import { formatInvalidDate } from '../../Utils/time.js';

function changeJobTitle(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(CHANGE_JOB_TITLE), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                jobTitle: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function changePhoneNumber(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(CHANGE_PHONE_NUMBER), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                phone: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var uploadFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, resumeId = _a.resumeId, apiUploadVersion = _a.apiUploadVersion, action = _a.action;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorSystem, formData, endPointUploadResumeFile, response, responeJson, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorSystem = new ModelError({
                        data: file,
                        error: {
                            details: {
                                ERROR_UPLOAD: langCode === ELanguage.EN ? "Can't not upload file" : 'Không thể tải tệp lên'
                            },
                            message: langCode === ELanguage.EN ? "Can't not upload file" : 'Không thể tải tệp lên',
                            status: 500
                        }
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    if (resumeId && resumeId > 0) {
                        formData.append('resume_id', resumeId.toString());
                        // When resumeId is provided it always replaced
                        formData.append('is_replaced', 'true');
                    }
                    // Action=1 param is used for by-pass old parsing cv flow
                    if (action) {
                        formData.append('action', action.toString());
                    }
                    endPointUploadResumeFile = "api-gateway/".concat(apiUploadVersion, "/").concat(ENDPOINT_UPDATE_RESUME_FILE);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(endPointUploadResumeFile), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    responeJson = _b.sent();
                    if (!responeJson.data) {
                        if (responeJson.Message || responeJson.Status === 400) {
                            return [2 /*return*/, new ModelError({
                                    data: file,
                                    error: {
                                        details: {
                                            ERROR_UPLOAD: responeJson.Message
                                        },
                                        message: responeJson.Message,
                                        status: responeJson.Status
                                    }
                                })];
                        }
                        return [2 /*return*/, errorSystem];
                    }
                    return [2 /*return*/, responeJson];
                case 4:
                    error_1 = _b.sent();
                    console.error('apiDoUpload ', error_1);
                    return [2 /*return*/, errorSystem];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var validateFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, userId = _a.userId, jobId = _a.jobId;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, data, error_2, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('jobId', jobId ? String(jobId) : '0');
                    formData.append('jobseekerId', userId ? String(userId) : '0');
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(ATTACHED_RESUME_VALIDATE), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_2 = _b.sent();
                    console.error('apiDoValidate ', error_2);
                    data = {
                        meta: {
                            statusCode: 413,
                            message: langCode === ELanguage.VI
                                ? 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'
                                : '.doc, .docx and .pdf files that are less than 5120KB in size'
                        }
                    };
                    return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getProfileLevel(accessToken, langCode, baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(PROFILE_LEVEL), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getResumeSettingInfo(accessToken, baseUrl, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(RESUME_SETTING_INFO, "?date=").concat(Date.now()), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    err_4 = _a.sent();
                    console.error(err_4);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var getJobLevelList = function (langCode, baseMsUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dataJs, relationships, err_5;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(JOBLEVEL), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                dataJs = _c.sent();
                relationships = (_a = dataJs === null || dataJs === void 0 ? void 0 : dataJs.data) === null || _a === void 0 ? void 0 : _a.relationships;
                if ((relationships === null || relationships === void 0 ? void 0 : relationships.data) && ((_b = relationships === null || relationships === void 0 ? void 0 : relationships.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return [2 /*return*/, relationships.data];
                }
                return [2 /*return*/, null];
            case 3:
                err_5 = _c.sent();
                console.error(err_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateProfileCookie = function (baseUrl, accessToken, body, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(PROFILE_COOKIE), {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error(error_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
function makeSearchable(baseUrl, accessToken, body, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(SEARCHABLE), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_6 = _a.sent();
                    console.error(err_6);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var makeRefreshProfile = function (baseMsUrl, accessToken, body, langCode) {
    if (langCode === void 0) { langCode = ELanguage.VI; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, data, e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(REFRESH_PROFILE), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    e_1 = _a.sent();
                    error = {
                        details: {
                            RESFRESH_PROFILE: 'ERROR_RESFRESH_PROFILE'
                        },
                        message: 'bad request',
                        status: 400
                    };
                    return [2 /*return*/, new ModelError({ data: e_1, error: error })];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getSkills(baseUrl, accessToken, searchKeywork, selectedSkills, limit, lang) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, response, jsonData, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    queryParams = __assign(__assign({ query: searchKeywork }, (!selectedSkills ? undefined : { selectedSkill: selectedSkills.join('|') })), (!limit ? undefined : { limit: limit }));
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(SKILL_TAGS, "?").concat(objToQueryStr(queryParams)), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': lang !== null && lang !== void 0 ? lang : ELanguage.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    jsonData = _a.sent();
                    return [2 /*return*/, jsonData.data];
                case 3: throw response;
                case 4:
                    error_4 = _a.sent();
                    console.log(error_4);
                    return [2 /*return*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function updateBasicInfo(baseUrl, accessToken, body, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(BASIC_INFO), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_7 = _a.sent();
                    console.error(err_7);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function updateSkills(baseMsUrl, accessToken, body, langCode, method) {
    if (method === void 0) { method = 'POST'; }
    return __awaiter(this, void 0, void 0, function () {
        var response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(USER_SKILL), {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_5 = _a.sent();
                    console.error(error_5);
                    return [2 /*return*/, {
                            errorCode: '',
                            message: '',
                            showMessage: true
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getUserProfile(accessToken, baseMsUrl, langCode) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseData, userProfileInfo, error_6;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(BASIC_INFO_V2), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _c.sent();
                    userProfileInfo = (_a = responseData.data) === null || _a === void 0 ? void 0 : _a.attributes;
                    if (userProfileInfo && userProfileInfo.birthday) {
                        userProfileInfo.birthday = formatInvalidDate(userProfileInfo.birthday, 'YYYY-MM-DD HH:MM:SS');
                    }
                    if (!userProfileInfo) {
                        return [2 /*return*/, new ModelError({
                                data: null,
                                error: {
                                    details: {
                                        ERROR: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.data) !== null && _b !== void 0 ? _b : ''
                                    },
                                    message: response.statusText,
                                    status: response.status
                                }
                            })];
                    }
                    return [2 /*return*/, userProfileInfo];
                case 3:
                    error_6 = _c.sent();
                    throw new ModelError(error_6);
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { changeJobTitle, changePhoneNumber, getJobLevelList, getProfileLevel, getResumeSettingInfo, getSkills, getUserProfile, makeRefreshProfile, makeSearchable, updateBasicInfo, updateProfileCookie, updateSkills, uploadFile, validateFile };
//# sourceMappingURL=index.js.map
